import type { ReactNode } from 'react';

/** Cabeçalho das páginas do perfil: título, descrição e ações à direita (como a Cloudflare) */
export function PerfilHeader({ title, description, actions, children }: { title: string; description?: ReactNode; actions?: ReactNode; children?: ReactNode }) {
  return (
    <div className="border-b border-kumo-line px-6 pt-6">
      <div className="flex items-start justify-between gap-4">
        <div className="pb-4">
          <h1 className="text-3xl font-semibold text-kumo-default">{title}</h1>
          {description && <p className="mt-2 text-sm text-kumo-subtle">{description}</p>}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

/** Cartão de seção (borda fina, cantos arredondados) */
export function Cartao({ title, badge, action, children }: { title: string; badge?: ReactNode; action?: ReactNode; children?: ReactNode }) {
  return (
    <section className="rounded-lg border border-kumo-line bg-kumo-base p-5">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <h2 className="flex items-center gap-2 text-base font-semibold text-kumo-default">{title}{badge}</h2>
          {children && <div className="mt-2 text-sm text-kumo-subtle">{children}</div>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </section>
  );
}

export function quando(iso: string | null | undefined) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'medium', timeStyle: 'short' });
}

export function ha(iso: string | null | undefined) {
  if (!iso) return '—';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'agora há pouco';
  if (s < 3600) return `há ${Math.floor(s / 60)} min`;
  if (s < 86400) return `há ${Math.floor(s / 3600)} h`;
  if (s < 86400 * 30) return `há ${Math.floor(s / 86400)} d`;
  if (s < 86400 * 365) return `há ${Math.floor(s / (86400 * 30))} mes`;
  return `há ${Math.floor(s / (86400 * 365))} a`;
}
